module.exports = __webpack_public_path__ + "src/app/assets/images/databiz.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/images/databiz.png
// module id = 640
// module chunks = 0